<template>
  <OrderCommonCard
    wx:if="{{discountTickets.length}}"
    class="card-wrapper"
    hideDivider
  >
    <image
      class="title"
      slot="title"
      mode="widthFix"
      src="https://ut-static.udache.com/webx/sfc/vr49hqRopzmoZ_99ZcARY_clipboard_image_1700210282723.png"
    />
    <view class="container">
      <view wx:for="{{discountTickets}}" wx:key="index" class="item" bindtap="onToDetail(item, index)">
        <view class="f-c-b">
          <view class="station">
            <view class="station-name" wx:class="{{ {overflow:item.depOverflow} }}">{{item.depCityName}}</view>
            <image class="icon" mode="widthFix" src="https://ut-static.udache.com/webx/sfc/iOS1MTlo8b6uWBWbFruwB.png"/>
            <view class="station-name" wx:class="{{ {overflow:item.arrOverflow} }}">{{item.arrCityName}}</view>
          </view>
          <view class="price">{{item.price}}</view>
        </view>
        <view class="f-e-b">
          <view class="date">{{item.date}}</view>
          <view wx:show="{{item.discount}}" class="discount">{{item.discount}}</view>
        </view>
      </view>
    </view>
  </OrderCommonCard>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import { trackEvent } from '@/common/track'
  import { getDiscountTickets } from '@/api/flights'
  import { locate } from '@didi/spring-base'
  import dayjs from 'dayjs'
  import 'dayjs/locale/zh-cn'
  import onShowHandleMixins from '@/mixins/homeTabOnShowHandleMixins'
  dayjs.locale('zh-cn')

  createComponent({
    mixins: [onShowHandleMixins],
    data: {
      discountTickets: []
    },
    methods: {
      async onShowHandle() {
        this.getTickets()
      },
      async getTickets() {
        const { tripCityId } = await locate()
        const ret = await getDiscountTickets({
          cityId: tripCityId,
        })
        if(ret.code === 200) {
          this.discountTickets = (ret.data || []).map(i => {
            const { 
              depCityName,
              arrCityName,
              depDateTime,
              discount
            } = i
            const _overflow = (depCityName + arrCityName).length >= 6
            return {
              ...i,
              depCityName,
              arrCityName,
              discount: discount ? `${(discount*10).toFixed(2).replace(/\.?0+$/, '')}折` : '',
              depOverflow: depCityName.length >= 3 && _overflow,
              arrOverflow: arrCityName.length >= 3 && _overflow,
              depDateTime: `${dayjs(depDateTime).format('YYYY-MM-DD')}`,
              date: `${dayjs(depDateTime).format('MM月D日 周dd')}`
            }
          })
        }
      },
      onToDetail(item, idx) {
        trackEvent('userteam_plane_home_special_ck', 'UT-飞机票-首页-特价机票按钮-点击', {
          type: idx+1,
          txt: JSON.stringify(item),
        })
        this.triggerEvent('specialTicketTap', {
          type: 'detail',
          item,
        })
      },
    }
  })
</script>

<style lang="stylus" scoped>
.card-wrapper
  border-radius 16px
.title
  width 64px
.container
  display flex
  flex-wrap wrap
  justify-content space-between
  font-size 12px
  line-height 1
  .item
    width calc(50% - 4px)
    height 62px
    padding 12px 8px
    box-sizing border-box
    border 1px solid #eeeeee
    border-radius 10px
    display flex
    flex-direction column
    justify-content space-between
    white-space nowrap
    margin-bottom 8px
    font-size 12px
    &:nth-last-child(-n+2)
      margin-bottom 0
    .f-c-b
      display flex
      align-items center
      justify-content space-between
    .f-e-b
      display flex
      align-items flex-end
      justify-content space-between
    .station
      font-size 14px
      color #333
      font-family PingFangSC-Medium
      font-weight 500
      line-height 18px
      display flex
      align-items center
      flex-shrink 1
      overflow hidden
      &-name
        flex none
        &.overflow
          flex-shrink 1
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
      .icon
        flex none
        width 10px
        margin 0 4px
    .price
      font-family Barlow Semi Condensed
      font-weight 500
      font-size 18px
      color #FF6400
      flex none
      display flex
      align-items center
      &::before
        content '¥'
        font-family PingFang SC
        font-size 16px
        font-weight 500
        transform translateY(1px) translateX(-1px)
    .date
      font-weight 400
      color #666
    .discount
      color #FF6400
</style>

<script  name="json">
  module.exports = {
    usingComponents: {
      'OrderCommonCard': '@/components/order-common-card',
    }
  }
</script>